import * as React from 'react';
import { FormControlLabel, FormControlLabelClasses } from '@mui/material';
import cn from 'classnames';

import { Checkbox } from '../../../../../BaseComponents';
import { useTheme } from '../../../../../theme';

interface Props {
	className?: string;
	classes?: Partial<FormControlLabelClasses>;
	label: React.ReactNode;
	isSelected: boolean;
	isDisabled?: boolean;
	onChange: (checked: boolean) => void;
}

const ExchangeRefundSelectControl: React.FC<Props> = ({
	className,
	classes,
	label,
	isSelected,
	isDisabled,
	onChange
}) => {
	const { ExchangeRefundSelectControl: theme } = useTheme('Entities').Order;

	const onChangeHandler = (_: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
		onChange(checked);
	};

	return (
		<FormControlLabel
			className={className}
			disabled={isDisabled}
			classes={{
				...classes,
				root: cn(theme.root, classes?.root, {
					[theme.root_checked]: isSelected,
					[theme.root_disabled]: isDisabled
				}),
				label: cn(theme.label, classes?.label)
			}}
			control={<Checkbox checked={isSelected} disabled={isDisabled} onChange={onChangeHandler} />}
			label={label}
		/>
	);
};

export default ExchangeRefundSelectControl;
